/**
 * QuestionMetaBadgesV2 - Displays question metadata as badges
 *
 * Shows:
 * - Domain (e.g., Algebra, Geometry)
 * - Skill
 * - Difficulty (Easy, Medium, Hard)
 */

import { memo } from 'react'

const QuestionMetaBadgesV2 = memo(({ question }) => {
  if (!question) return null

  // Difficulty colors
  const difficultyConfig = {
    E: {
      label: 'Easy',
      className: 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400'
    },
    M: {
      label: 'Medium',
      className: 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400'
    },
    H: {
      label: 'Hard',
      className: 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400'
    }
  }

  const difficulty = question.difficulty || 'M'
  const diffConfig = difficultyConfig[difficulty] || difficultyConfig.M

  return (
    <div className="flex flex-wrap items-center gap-2">
      {/* Domain badge */}
      {question.domain && (
        <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-400">
          {question.domain}
        </span>
      )}

      {/* Skill badge */}
      {question.skill && (
        <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 max-w-[150px] truncate">
          {question.skill}
        </span>
      )}

      {/* Difficulty badge */}
      <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${diffConfig.className}`}>
        {diffConfig.label}
      </span>

      {/* Question ID (dev mode only) */}
      {process.env.NODE_ENV === 'development' && (
        <span className="px-2 py-0.5 text-[10px] font-mono rounded bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400">
          {question.id?.slice(0, 8)}
        </span>
      )}
    </div>
  )
})

QuestionMetaBadgesV2.displayName = 'QuestionMetaBadgesV2'

export default QuestionMetaBadgesV2
